<template>
  <div id="compreSportsMeet_medalDetailList" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        v-if="selectOptData"
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
        :manualRefresh="selectOpt_manualRefresh"
      ></marathon_select_opt>
    </div>
    <template v-if="themeItem && medalList && medalList.length > 0">
      <multipleChoiceShare_fixedBtn
        :model="multipleChoiceShareFixedBtn_model"
        :state="multipleChoiceShareFixedBtn_state"
        :modeType="multipleChoiceShareFixedBtn_modeType"
        :smallBtnArr="smallBtnArr"
        :fixedBtn_absTopArr="['18vw', '21vw']"
        @changeModelEvent="changeModelEventHandler"
        @clickSmallBtnEvent="clickSmallBtnEventHandler"
        @clickFixedBtnEvent="clickFixedBtnEventHandler"
        :isShow="!noData"
      ></multipleChoiceShare_fixedBtn>
    </template>
    <div
      class="teamTable"
      :class="
        multipleChoiceShareFixedBtn_model === 'circular'
          ? 'multipleChoiceShare_fixedBtn_isCircular'
          : ''
      "
    >
      <div class="tableScrollArea" ref="tableParentDom">
        <div :class="scrollDomClassName">
          <medal_detailList
            :currCid="currCid"
            :currSid="currSid"
            :currThemeObj="currThemeObj"
            :data="medalList"
            :chooseState="multipleChoiceShareFixedBtn_state"
            :localStorageName="
              multipleChoiceShareFixedBtn_modeType &&
              multipleChoiceShareFixedBtn_modeType.localStorageName
                ? multipleChoiceShareFixedBtn_modeType.localStorageName
                : ''
            "
            :localStorageSaveDate="currStageMatchDate"
            @changeChooseNumEvent="changeChooseNumEventHandler"
          ></medal_detailList>
        </div>
        <!-- <p class="loadingClass" v-show="loading">加载中...</p> -->
        <p class="noMoreClass" v-show="noMore">没有更多了</p>
        <p class="noDataClass" v-show="noData">暂无数据</p>
      </div>
    </div>

    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
    <complex_multipleChoiceShare_dialog
      v-if="dialogItem && dialogItem.isDialogFlag"
      :currThemeObj="currThemeObj"
      :axiosBaseUrl="axiosBaseUrl"
      :platfromMenu_currGroup="currGroup"
      :currCid="currCid"
      :currSid="currSid"
      :dialogItem="dialogItem"
      :themeItem="themeItem"
      :localStorageChooseList="localStorageChooseList"
      :multipleChoiceShareFixedBtn_modeType="
        multipleChoiceShareFixedBtn_modeType
      "
      :curTimeZoneItem="curTimeZoneItem"
      @dialogCancelEvent="clickSmallBtnEventHandler"
      @dialogOkEvent="dialogOkEventHandler"
      @shareDoneEvent="shareDoneEventHandler"
    >
      <template v-slot:checkList>
        <medal_detailList
          :currCid="currCid"
          :currSid="currSid"
          :currThemeObj="currThemeObj"
          :data="localStorageChooseList"
          :chooseState="multipleChoiceShareFixedBtn_state"
          :localStorageName="
            multipleChoiceShareFixedBtn_modeType &&
            multipleChoiceShareFixedBtn_modeType.localStorageName
              ? multipleChoiceShareFixedBtn_modeType.localStorageName
              : ''
          "
          :localStorageSaveDate="currStageMatchDate"
          :renderMode="'checkList'"
          @changeChooseNumEvent="changeChooseNumEventHandler"
        ></medal_detailList>
      </template>
    </complex_multipleChoiceShare_dialog>
  </div>
</template>

<script>
import {
  https_medalDetail_dateSports,
  https_sportsList,
  https_select_delegationList,
  https_medalDetail_list,
} from '@api/platfrom_compreSportsMeet_api'
import BackTop from '@components/base/backTop.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import medal_detailList from '@components/platfromBase/compreSportsMeet/medal_detailList.vue'
import multipleChoiceShare_fixedBtn from '@components/platfromBase/compreSportsMeet/multipleChoiceShare_fixedBtn.vue'
import complex_multipleChoiceShare_dialog from '@components/platfromBase/compreSportsMeet/complex_multipleChoiceShare_dialog.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import multipleChoiceShare_data_mixin from '@mixins/multipleChoiceShare_data'

export default {
  name: 'compreSportsMeet_medalDetailList',
  components: {
    marathon_select_opt,
    BackTop,
    multipleChoiceShare_fixedBtn,
    complex_multipleChoiceShare_dialog,
    medal_detailList,
  },
  mixins: [cup_base_data_mixin, multipleChoiceShare_data_mixin],
  props: {
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    bigSportsList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      // select_opt_inputObject: {
      //   inputTitle: '快速查询',
      //   placeholder: '请输入比赛名称',
      //   iconType: 'search',
      // }, //控制marathon_select_opt中的输入框是否显示
      isScrollBottom: false,
      scrollDomClassName: 'scrollDomContain',
      scrollDomById: 'containerFull_body',
      currStageMatchDate: '',
      currStageBigSports: '',
      currStageDelegation: '',
      // curInputVal: '',
      selectAllObj: {
        value: 'all',
        name: '全部',
      },
      matchDateArr: [],
      bigSportsArr: [],
      delegationArr: [],
      selectOptData_origin: {
        configArr: [
          {
            type: 'matchDate',
            title: '日期',
            origin_keyVal: ['value', 'name'],
            dataName: 'matchDateArr',
            selectIndex: 0,
          },
          {
            type: 'bigSports',
            title: '项目',
            origin_keyVal: ['value', 'name'],
            dataName: 'bigSportsArr',
            selectIndex: 0,
            isFilterable: true,
          },
          {
            type: 'delegation',
            title: '代表团',
            origin_keyVal: ['value', 'name'],
            dataName: 'delegationArr',
            selectIndex: 0,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      },
      selectOptData: null,
      showBackTop: false,
      themeTemplateType: 16,
      multipleChoiceShareFixedBtn_modeType: {
        btnName: '创建奖牌',
        localStorageName: 'mixtmt_choose_medal',
        unit: '条',
      },
      medalList: null,
    }
  },
  created() {
    if (this.currGroup) {
      this.init()
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', () => {
      this.scrollListenerEvent()
    })
  },
  computed: {
    noMore() {
      return this.medalList && this.medalList.length > 0
    },
    noData() {
      return this.medalList && this.medalList.length === 0
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.selectOptData = JSON.parse(JSON.stringify(this.selectOptData_origin))
      console.debug(this.currCid, this.currSid)
      if (this.initFindanalysisItem && (!this.themeItem || !this.crossSeason)) {
        this.initFindanalysisItem()
      }
      await this.getStageDateSports()
      await this.getBigSportsList()
      await this.getDelegationList()
      await this.getMedalDetailList()
      if (this.matchDateArr.length > 0) {
        if (this.delegationArr.length > 1) {
          // 初始化，默认选第一个代表团
          this.selectOptData.configArr[2].selectIndex = 1
        }
        this.computedSelectOpt(this.selectOptData.configArr)
      }

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async selectOpt_manualRefresh() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await this.getMedalDetailList()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    scrollListenerEvent() {
      const scrollTop = this.scrollAreaDom.scrollTop
      const scrollHeight = this.scrollAreaDom.scrollHeight
      const parentHeightPx = this.scrollAreaDom.offsetHeight
      let direction = this.DIRECTION_ENUM.DOWN
      if (this.beforeScrollTop > scrollTop) {
        direction = this.DIRECTION_ENUM.UP
      }
      // 通过滚动方向判断是触底还是触顶
      // console.debug(
      //   'direction:',
      //   direction,
      //   scrollTop,
      //   parentHeightPx,
      //   scrollHeight,
      //   this.isScrollBottom,
      //   this.matchTotal,
      //   this.curMatchListNum
      // )
      if (scrollTop > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }
      // if (scrollTop > 0) {
      //   this.changeMatchLabelFixed(scrollTop, direction)
      // }

      // if (scrollTop > 5) {
      //   this.multipleChoiceShareFixedBtn_model = 'circular'
      // } else {
      //   if (this.multipleChoiceShareFixedBtn_model === 'rect') {
      //     this.multipleChoiceShareFixedBtn_model = 'rect'
      //   }
      // }
      this.scrollChangeHandler(scrollTop)
      // if (direction == this.DIRECTION_ENUM.DOWN) {
      //   // 滚动触底
      //   if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
      //     console.debug('滚动触底')
      //     this.load()
      //     if (this.pnum > this.allPages) {
      //       this.isScrollBottom = true
      //     }
      //   }
      // } else {
      //   // 滚动到顶部
      //   this.isScrollBottom = false
      //   if (scrollTop <= this.threshold) {
      //     console.debug('滚动到顶部')
      //   }
      // }
      this.beforeScrollTop = this.scrollAreaDom.scrollTop
    },
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }
      // this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      // console.debug(
      //   'this.parentWidthPx:',
      //   this.$refs.tableParentDom.scrollHeight
      // )
      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      // window.addEventListener('resize', () => {
      //   this.onResizeEvent()
      // })

      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)

      // console.debug(this.scrollAreaDom)
      this.scrollAreaDom.addEventListener('scroll', () => {
        this.scrollListenerEvent()
      })
    },
    changeChooseNumEventHandler(data) {
      console.debug(data)
      let medalList = JSON.parse(JSON.stringify(this.medalList))
      if (data.init) {
        // 清除缓存，重新开始
        this.$localStorage.removeItem(
          data.localStorageName //this.multipleChoiceShareFixedBtn_modeType.localStorageName
        )
        medalList.forEach((item) => {
          item.isChooseFlag = false
        })
      } else {
        const chooseSchedule = JSON.parse(
          this.$localStorage.getItem(
            data.localStorageName //this.multipleChoiceShareFixedBtn_modeType.localStorageName
          )
        )

        medalList.forEach((item) => {
          if (chooseSchedule.chooseIdArr.includes(item.chooseId)) {
            item.isChooseFlag = true
          } else {
            item.isChooseFlag = false
          }
        })
        this.localStorageChooseList = chooseSchedule.chooseItemArr
      }
      this.medalList = medalList
      console.debug(this.medalList)
      this.smallBtnArr.forEach((item) => {
        if (item.type === 'check') {
          item.val = data.val
        }
      })
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = this[config.dataName].map((item) => {
          item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
          return item
        })
        console.debug(
          'computedSelectOpt:',
          config.dataName,
          this[config.dataName],
          list,
          mix_id
        )
        selectOpt_list.push({
          type: config.type,
          title: config.title,
          keyVal: [mix_id, config.origin_keyVal[1]],
          curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
          curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
          disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
          isFilterable: config.isFilterable ? config.isFilterable : false,
          list,
        })
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'matchDate') {
            // let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))
            this.currStageMatchDate = valPathArr[1]
            // let originDateBigSportsArr = this.originDateBigSportsArr
            // originDateBigSportsArr.forEach((item, itemIndex) => {
            //   if (item.value === valPathArr[1]) {
            //     // console.debug('asdadsada:', item, valPathArr)
            //     item.selected = true
            //     this.selectOptData.configArr[0].selectIndex = itemIndex
            //     let bigSportsArr = item.disciplines
            //       ? item.disciplines.map((ceil) => {
            //           return {
            //             value: ceil.disciplineCode,
            //             name: ceil.disciplineName,
            //           }
            //         })
            //       : []

            //     let actSportsIndex = 0
            //     this.bigSportsArr = [].concat(selectAllObj, bigSportsArr)
            //     if (this.bigSportsArr.length > 1) {
            //       this.bigSportsArr.forEach((sportItem, sportIndex) => {
            //         if (sportItem.value === this.currStageBigSports) {
            //           // 切换的比赛日期中有之前的大项，所以保留大项
            //           actSportsIndex = sportIndex
            //         }
            //       })
            //     }
            //     this.currStageBigSports =
            //       this.bigSportsArr[actSportsIndex].value
            //     this.selectOptData.configArr[1].selectIndex = actSportsIndex
            //   } else {
            //     item.selected = false
            //   }
            // })
            // this.originDateBigSportsArr = originDateBigSportsArr
            // this.computedSelectOpt(this.selectOptData.configArr)
          } else if (valPathArr[0] === 'bigSports') {
            this.currStageBigSports = valPathArr[1]
          } else if (valPathArr[0] === 'delegation') {
            this.currStageDelegation = valPathArr[1]
            // this.delegationArr.forEach((teamItem, teamIndex) => {
            //   if (valPathArr[1] === teamItem.value) {
            //     this.selectOptData.configArr[2].selectIndex = teamIndex
            //   }
            // })
          } else {
          }
          console.debug(
            'bigSports bigSports:',
            this.selectOptData,
            this.bigSportsArr
          )
          // 筛选表格逻辑
          // this.initMatchListQuery()
          // this.getScheduleMatchList()
          this.getMedalDetailList()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    async getStageDateSports() {
      await https_medalDetail_dateSports(this.axiosBaseUrl, this.$axios, {
        cid: this.currCid,
        sid: this.currSid,
        timeZone: this.curTimeZoneItem.val, // 'beijing',
      })
        .then((response) => {
          const res = response.data

          if (res.status === 0) {
            if (res.data && res.data.length > 0) {
              let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))

              // let allDateBigSportsArr = [] //组装全部日期下所有大项数组
              // let originDateBigSportsArr = res.data.map((item) => {
              //   item.disciplines.forEach((orgin_sportItem) => {
              //     let isPushFlag = true
              //     if (allDateBigSportsArr.length === 0) {
              //       allDateBigSportsArr.push(
              //         JSON.parse(JSON.stringify(orgin_sportItem))
              //       )
              //     } else {
              //       allDateBigSportsArr.forEach((allDateSportItem) => {
              //         if (
              //           allDateSportItem.disciplineCode ===
              //           orgin_sportItem.disciplineCode
              //         ) {
              //           isPushFlag = false
              //         }
              //       })
              //       if (isPushFlag) {
              //         allDateBigSportsArr.push(
              //           JSON.parse(JSON.stringify(orgin_sportItem))
              //         )
              //       }
              //     }
              //   })
              //   return {
              //     value: item.date,
              //     name: item.dateFormatter,
              //     disciplines: item.disciplines,
              //     selected: item.selected,
              //   }
              // })

              let matchDateArr = res.data
                ? res.data.map((item, itemIndex) => {
                    if (item.selected) {
                      this.currStageMatchDate = item.date
                      this.selectOptData.configArr[0].selectIndex =
                        itemIndex + 1 //因为有数据，再加上【全部】，所以索引+1

                      // let bigSportsArr = item.disciplines
                      //   ? item.disciplines.map((ceil) => {
                      //       return {
                      //         value: ceil.disciplineCode,
                      //         name: ceil.disciplineName,
                      //       }
                      //     })
                      //   : []
                      // let actIndex = 0
                      // if (bigSportsArr.length > 1) {
                      //   this.bigSportsArr = [].concat(
                      //     selectAllObj,
                      //     bigSportsArr
                      //   )
                      //   actIndex = 1
                      // } else {
                      //   this.bigSportsArr = bigSportsArr
                      // }
                      // this.currStageBigSports =
                      //   this.bigSportsArr[actIndex].value
                    }
                    return {
                      value: item.date,
                      name: item.dateFormatter,
                    }
                  })
                : []

              // 重新组装原始日期+大项数据
              // this.originDateBigSportsArr = [].concat(
              //   [
              //     {
              //       value: 'all',
              //       name: '全部',
              //       disciplines: allDateBigSportsArr,
              //       selected: false,
              //     },
              //   ],
              //   originDateBigSportsArr
              // )
              this.matchDateArr = [].concat(
                JSON.parse(JSON.stringify(this.selectAllObj)),
                matchDateArr
              )
              console.debug('getStageDateSports:', this.bigSportsArr)
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getBigSportsList() {
      await https_sportsList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))
              let bigSportsArr = res.data
                ? res.data.map((ceil) => {
                    return {
                      value: ceil.disciplineCode,
                      name: ceil.disciplineName,
                    }
                  })
                : []
              let actIndex = 0
              this.bigSportsArr = [].concat(selectAllObj, bigSportsArr)
              this.currStageBigSports = this.bigSportsArr[actIndex].value
            } else {
              this.bigSportsApiList = []
              console.debug('暂无数据')
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getDelegationList() {
      let params = {
        sid: this.currSid,
      }
      await https_select_delegationList(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))
            this.delegationArr = res.data
              ? [].concat(
                  selectAllObj,
                  res.data.map((item) => {
                    return {
                      value: item.organisationCode,
                      name: item.organisationName,
                    }
                  })
                )
              : []
            let actIndex = 0
            if (this.delegationArr.length > 1) {
              actIndex = 1
            }
            this.currStageDelegation = this.delegationArr[actIndex].value
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    computedMedalList(arr) {
      return arr.map((item) => {
        item.matchName = `${this._valPerFormatHandler(
          item.disciplineName
        )}·${this._valPerFormatHandler(item.eventName)}`
        item.athleteNames = item.athleteInfos.map((player) => {
          return player.athleteName
        })
        item.palyerNames =
          item.athleteNames && item.athleteNames.length > 1
            ? item.athleteNames.join(' / ')
            : item.athleteNames[0]
        item.chooseId = item.medalKey

        item.delegationLogo = item.organisationLogo
        item.delegationId = item.organisationCode
        item.delegationName = this._valPerFormatHandler(item.organisationName)
        return item
      })
    },
    async getMedalDetailList() {
      await https_medalDetail_list(this.axiosBaseUrl, this.$axios, {
        cid: this.currCid,
        sid: this.currSid,
        date: this.currStageMatchDate === 'all' ? '' : this.currStageMatchDate,
        disciplineCode:
          this.currStageBigSports === 'all' ? '' : this.currStageBigSports,
        orgCode:
          this.currStageDelegation === 'all' ? '' : this.currStageDelegation,
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              this.medalList = this.computedMedalList(res.data)
              this.initScroll()
            } else {
              console.debug('暂无数据')
              this.medalList = []
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#compreSportsMeet_medalDetailList {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .teamTable {
    padding: 5.25vw 0 6.964vw;
    transition: padding 0.2s linear;
    &.multipleChoiceShare_fixedBtn_isCircular {
      padding: 2.776vw 0 6.964vw;
    }
    .tableScrollArea {
      position: relative;
      /* .scrollDomContain {
        max-height: calc(100vh - 19.142vw);
        overflow: auto;
      } */
    }
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
}
/* .mixtmt_pc #compreSportsMeet_medalDetailList {
  
} */
</style>
